import { __assign, __awaiter, __generator } from "tslib";
import { AddToCartActionOption, APP_DEFINITION_ID, TrackEventName, createOOIStoreFrontBILogger, } from '@wix/wixstores-client-core';
import { ONLINE_STORES_SPECS } from './constants';
import { removeUndefinedKeys } from '../../lib/removeUndefinedKeys';
export function createViewerScript() {
    var _this = this;
    var context = {};
    return {
        initAppForPage: function (_initParams, _apis, wixAPI, platformServices) {
            context.wixAPI = wixAPI;
            context.experiments = platformServices.essentials.experiments;
            if (context.experiments.enabled(ONLINE_STORES_SPECS.UseCurrentCartFromSdk) &&
                context.experiments.enabled(ONLINE_STORES_SPECS.UseAddToCurrentCart)) {
                context.biLogger = createOnlineStoresBiLogger(wixAPI, platformServices);
            }
            context.trackEvent = wixAPI.window.trackEvent;
            return Promise.resolve();
        },
        createControllers: function () { return null; },
        exports: {
            cart: {
                addToCart: function (productId, quantity, options, preOrderRequested, trackData) { return __awaiter(_this, void 0, void 0, function () {
                    var ecomPlatformPublicAPI, ecomPlatformPublicAPI;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(context.experiments.enabled(ONLINE_STORES_SPECS.UseCurrentCartFromSdk) &&
                                    context.experiments.enabled(ONLINE_STORES_SPECS.UseAddToCurrentCart))) return [3 /*break*/, 3];
                                return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                            case 1:
                                ecomPlatformPublicAPI = _b.sent();
                                // TODO: replace with ecomPlatformPublicAPI.cart.addToCurrentCart
                                return [4 /*yield*/, ecomPlatformPublicAPI.cart.addToCart(productId, quantity, __assign(__assign({}, options), { addToCartAction: AddToCartActionOption.NONE }), preOrderRequested, trackData)];
                            case 2:
                                // TODO: replace with ecomPlatformPublicAPI.cart.addToCurrentCart
                                _b.sent();
                                void trackAddToCartEvent(ecomPlatformPublicAPI, context, {
                                    productId: "".concat(productId),
                                    quantity: Number(quantity),
                                    variantId: options === null || options === void 0 ? void 0 : options.variantId,
                                    trackData: trackData,
                                });
                                reportAddToCartBI(context, {
                                    origin: 'addToCart',
                                    productId: "".concat(productId),
                                    quantity: Number(quantity),
                                    hasOptions: Object.keys((_a = options === null || options === void 0 ? void 0 : options.choices) !== null && _a !== void 0 ? _a : {}).length > 0,
                                    trackData: trackData,
                                });
                                return [2 /*return*/, handleAddToCartAction(ecomPlatformPublicAPI, options === null || options === void 0 ? void 0 : options.addToCartAction, "".concat(productId))];
                            case 3: return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                            case 4:
                                ecomPlatformPublicAPI = _b.sent();
                                return [2 /*return*/, ecomPlatformPublicAPI.cart.addToCart(productId, quantity, options, preOrderRequested, trackData)];
                        }
                    });
                }); },
                addProducts: function (items, options) { return __awaiter(_this, void 0, void 0, function () {
                    var ecomPlatformPublicAPI;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                            case 1:
                                ecomPlatformPublicAPI = _a.sent();
                                if (!(context.experiments.enabled(ONLINE_STORES_SPECS.UseCurrentCartFromSdk) &&
                                    context.experiments.enabled(ONLINE_STORES_SPECS.UseAddToCurrentCart))) return [3 /*break*/, 3];
                                // TODO: replace with ecomPlatformPublicAPI.cart.addToCurrentCart
                                return [4 /*yield*/, ecomPlatformPublicAPI.cart.addProducts(items, options)];
                            case 2:
                                // TODO: replace with ecomPlatformPublicAPI.cart.addToCurrentCart
                                _a.sent();
                                items.forEach(function (item) {
                                    var _a;
                                    trackAddToCartEvent(ecomPlatformPublicAPI, context, {
                                        productId: item.productId,
                                        quantity: item.quantity,
                                    });
                                    reportAddToCartBI(context, {
                                        origin: 'addProducts',
                                        productId: "".concat(item.productId),
                                        quantity: Number(item.quantity),
                                        hasOptions: Object.keys((_a = item.options.choices) !== null && _a !== void 0 ? _a : {}).length > 0,
                                    });
                                });
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, ecomPlatformPublicAPI.cart.addProducts(items, options)];
                            case 4:
                                _a.sent();
                                _a.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                }); },
            },
        },
    };
}
function handleAddToCartAction(ecomPlatformPublicAPI, addToCartAction, addedProductId) {
    if (addToCartAction === void 0) { addToCartAction = AddToCartActionOption.MINI_CART; }
    return __awaiter(this, void 0, void 0, function () {
        var hasCartIcon, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ecomPlatformPublicAPI.cart.hasCartIcon()];
                case 1:
                    hasCartIcon = _c.sent();
                    if (!(addToCartAction === AddToCartActionOption.MINI_CART ||
                        (addToCartAction === AddToCartActionOption.NONE && !hasCartIcon))) return [3 /*break*/, 6];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.openSideCart()];
                case 3: return [2 /*return*/, _c.sent()];
                case 4:
                    _a = _c.sent();
                    return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                case 5: return [3 /*break*/, 12];
                case 6:
                    if (!(addToCartAction === AddToCartActionOption.TINY_CART)) return [3 /*break*/, 11];
                    _c.label = 7;
                case 7:
                    _c.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, ecomPlatformPublicAPI.cart.showTinycart({ addedProductId: addedProductId })];
                case 8: return [2 /*return*/, _c.sent()];
                case 9:
                    _b = _c.sent();
                    return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                case 10: return [3 /*break*/, 12];
                case 11:
                    if (addToCartAction === AddToCartActionOption.CART) {
                        return [2 /*return*/, ecomPlatformPublicAPI.navigate.toCart()];
                    }
                    _c.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    });
}
function createOnlineStoresBiLogger(wixAPI, platformServices) {
    var user = wixAPI.window.viewMode === 'Site'
        ? { visitor_id: platformServices.bi.visitorId }
        : { uuid: platformServices.bi.ownerId };
    return createOOIStoreFrontBILogger(user, platformServices.bi.biToken, {
        isMerchant: false,
        appName: 'Stores',
        _msid: platformServices.bi.metaSiteId,
    }, platformServices.biLoggerFactory());
}
function reportAddToCartBI(context, _a) {
    var origin = _a.origin, productId = _a.productId, hasOptions = _a.hasOptions, quantity = _a.quantity, trackData = _a.trackData;
    void context.biLogger.clickOnAddToCartSf(removeUndefinedKeys({
        productId: productId,
        quantity: quantity,
        hasOptions: hasOptions,
        origin: origin,
        buttonType: trackData === null || trackData === void 0 ? void 0 : trackData.buttonType,
        appName: trackData === null || trackData === void 0 ? void 0 : trackData.appName,
        isNavigateCart: trackData === null || trackData === void 0 ? void 0 : trackData.isNavigateCart,
        navigationClick: trackData === null || trackData === void 0 ? void 0 : trackData.navigationClick,
        productType: trackData === null || trackData === void 0 ? void 0 : trackData.productType,
        impressionId: trackData === null || trackData === void 0 ? void 0 : trackData.impressionId,
        galleryProductsLogic: trackData === null || trackData === void 0 ? void 0 : trackData.galleryProductsLogic,
        rank: trackData === null || trackData === void 0 ? void 0 : trackData.rank,
        galleryInputId: trackData === null || trackData === void 0 ? void 0 : trackData.galleryInputId,
    }));
}
function trackAddToCartEvent(ecomPlatformPublicAPI, context, _a) {
    var _b, _c, _d;
    var productId = _a.productId, quantity = _a.quantity, variantId = _a.variantId, trackData = _a.trackData;
    return __awaiter(this, void 0, void 0, function () {
        var cart;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, ecomPlatformPublicAPI.cart.getCurrentCart()];
                case 1:
                    cart = _e.sent();
                    context.trackEvent(TrackEventName.ADD_TO_CART, removeUndefinedKeys({
                        cartId: (_b = cart.cartId) !== null && _b !== void 0 ? _b : undefined,
                        currency: (_d = (_c = cart.convertedCurrencyFormat) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : undefined,
                        id: productId,
                        quantity: quantity,
                        name: trackData === null || trackData === void 0 ? void 0 : trackData.name,
                        sku: trackData === null || trackData === void 0 ? void 0 : trackData.sku,
                        price: trackData === null || trackData === void 0 ? void 0 : trackData.price,
                        type: trackData === null || trackData === void 0 ? void 0 : trackData.type,
                        category: trackData === null || trackData === void 0 ? void 0 : trackData.category,
                        variantId: variantId,
                    }));
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=viewerScript.js.map